import React, { useState, useRef, useCallback, useEffect, useSyncExternalStore } from "react";
import InitialScreening from "./InitialScreening";
import ReportDefault from "./default";
import jsCookie from "js-cookie";
import SourcesData from "./DataSources";
import TemplateReport from "./ReportTemplate";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux";
import { LoadingIcon } from "src/components/icons";
import ChatQuery from "src/components/@vc-product/chat-question";
import QueryAnswer from "src/components/@vc-product/query-answer";
import Modal from "src/components/reusable/modal";
import { Switch } from "@headlessui/react";
import debounce from "lodash.debounce";
import { AppConfig } from "src/config/app.config";
import DotLoader from "src/components/reusable/dot-loader";
import {
  generateAgentThreadName,
  generateKnowId,
  generateKnowIdstring,
  getRandomErrorMessage,
  processResponse,
} from "src/utils/helpers";
import ExtractInfo from "./extractInfo";
import {
  sendQuery,
  extractFileData,
  updatePitchdeckData,
  dynamicThreadName,
} from "src/stores/vs-product";

import {
  setVSChats,
  setprevres,
  setCurrentStep,
  resetChats,
  updateChatQuery,
  setCompanyName,
  updateButtonSelection,
  setUploadStatus,
} from "src/stores/vs-product";
import StepBar from "./stepBar";
import { useNavigate, useSearchParams } from "react-router-dom";
import ReportCustomization from "./ReportCustomization";
import axios from "axios";
import AddQueryAgent from "./add-query";
import { endChatThread, initQuantChat, quantAgnetUploadFiles, sendAiAgentQuery } from "./action";
import LoadingUI from "./LoadingUi";
import { v4 as uuidv4 } from "uuid";
import AgentHead from "./AgentHead";
import { fetchAgentThreadDetails } from "src/pages/my-account/my-agent-reports/agent-report.action";
import { useListing } from "src/layouts/sidebar/DraftProvider";
import { Link } from "react-router-dom";
import ArrowLeftIcon from "src/components/icons/common/arrow-left";
import { API_PROD_URL } from "src/utils/axios";
import AgentInfo from "./AgentInfo";
import DiligenceAgentThinking from "./AgentInit";
import Keywords from "./Keywords";
import AutoMappedFields from "./AutoMappedField";
import { custStep1, custStep2, custStep3, custStep4, initStep1, initStep2 } from "./__mock__";
import StatusChecklist from "./CheckList";
import AutoFilledSummaryTable from "./AutoFilledSummary";
import ModelComponentsTable from "./SummaryPanel";
import FileUploaded from "./InvestmentAgentComponents/FileUploaded";
import QuickHealth from "./InvestmentAgentComponents/QuickHealth";
import ProposedCleanup from "./InvestmentAgentComponents/ProposedCleanup";
import ObjectiveConfirmation from "./InvestmentAgentComponents/ObjectiveConfirmation";
import VisualConfirmation from "./InvestmentAgentComponents/VisualConfirmation";
import SchemaValidation from "./InvestmentAgentComponents/FieldLevelDiagnostic";
import { interactiveReportInput } from "./interactive-report/action";
import CampaignTemplateReport from "./CampaignTemplateReport";
import ConnectorSetup from "src/components/connectors/ConnectorSetup";
import { json } from "stream/consumers";
import DataCollectionAdoptionAgent from "./adoptionAgentComponents/data-collection";
import SentimentInsightsUI from "./SentimentAnalysis";
import ChallengeMappingUI from "./ChallengeMapping";
import SupportStrategiesUI from "./SupportStrategy";
import PersonaSegmentation from "./PersonaSegmentation";
import ReportGeneration from "./ReportGeneration";
import CarTReport from "./CarTReport";
import { DragControls } from "framer-motion";
import PatientSegment from "./PatientSegment";
import InterviewGuide from "./InterviewGuide";
import TemplateConfirmation from "./TemplateConfirmation";
import NewsletterWireframe from "./newsletterAgentComponents/newsletter-wireframe";
import NewsletterContextPreview from "./newsletterAgentComponents/newsletter-contextpreview";
import NewsletterEmailPreview from "./newsletterAgentComponents/newsletter-emailpreview";
import NewsletterContextAudit from "./newsletterAgentComponents/newsletter-contentaudit";
import NewsletterFinalOutput from "./newsletterAgentComponents/newsletter-finaloutput";
import QuantIngestionPanel from "./quantAgentComponents/QuantIngestionPanel";
import QuantValidationPanel from "./quantAgentComponents/QuantValidationPanel";
import QuantChartPanel from "./quantAgentComponents/QuantChartPanel";
import QuantInsightsPanel from "./quantAgentComponents/QuantInsightsPanel";
import TemplateQuantAgent from "./TemplateQuantAgent";
import PresentationRightPanel from "./PresentationRightPanel";
import ChartingPanel from "./ChartingPanel";
import NewsletterCollection from "./newsletterAgentComponents/newsletter-collection";
import EmailLayout from "./newsletterAgentComponents/emailLayout";
import ReportAnythingReport from "./reportAnythingReport";
import AnythingReportTemplate from "./reportAnythingComponent/anythingReportTemplate";
import StripeConnect from "./reportAnythingComponent/stripe-connect";
import Report from "./whitepaperReportComponents/Report";
import TableOfContent from "./whitepaperReportComponents/TableOfContent";
import WhitePaperDataSources from "./whitepaperReportComponents/WhitePaperDataSources";
import toast from "react-hot-toast";

export const AgentName: Record<string, string> = {
  "company-diligence-agent": "Company Diligence Agent",
  "fundraising-strategy-agent": "Fundraising Strategy Agent",
  "report-on-anything-agent": "Report on Anything Agent",
  "market-strategy-agent": "Market Strategy Agent",
  "portfolio-support-agent": "Portfolio Support Agent",
  "technology-agent": "Technology & R&D Agent",
  "product-engineering-agent": "Product & Engineering Agent",
  "corporate-venture-capital-agent": "Corporate Venture Capital Agent",
  "finance-strategy-agent": "Finance & Strategy Agent",
  "marketing-sales-agent": "Marketing & Sales Agent",
  "legal-compliance-agent": "Legal & Compliance Agent",
  "prior-art-agent": "Prior Art Agent",
  "patent-licensing-agent": "Patent Licensing Agent",
  "prosecution-history-agent": "Prosecution History Agent",
  "patent-landscape-agent": "Patent Landscape Agent",
  "fto-agent": "FTO Agent",
  "risk-horizon-mapping-agent": "Risk Horizon Mapping Agent",
  "financial-portfolio-optimization-agent": "Financial Portfolio Optimization Agent",
  "regulatory-impact-forecasting-agent": "Regulatory Impact Forecasting Agent",
  "emerging-market-opportunity-agent": "Emerging Market Opportunity Agent",
  "vendor-and-partner-risk-assessment-agent": "Vendor and Partner Risk Assessment Agent",
  "ma-opportunity-mapping-agent": "M and A Opportunity Mapping Agent",
  "payment-fraud-monitoring-agent": "Payment Fraud Monitoring Agent",
  "transactional-risk-pattern-agent": "Transactional Risk Pattern Agent",
  "invention-diligence-agent": "Invention Diligence Agent",
  "commercialization-strategy-agent": "Commercialization Strategy Agent",
  "licensing-opportunity-agent": "Licensing Opportunity Agent",
  "startup-spinout-support-agent": "Startup Spinout Support Agent",
  "technology-readiness-and-adoption-agent": "Technology Readiness and Adoption Agent",
  "esg-compliance-tracker-agent": "ESG Compliance Tracker Agent",
  "sustainability-risk-assessment-agent": "Sustainability Risk Assessment Agent",
  "green-innovation-opportunity-agent": "Green Innovation Opportunity Agent",
  "carbon-market-intelligence-agent": "Carbon Market Intelligence Agent",
  "vendor-risk-mapping-agent": "Vendor Risk Mapping Agent",
  "operational-efficiency-diligence-agent": "Operational Efficiency Diligence Agent",
  "third-party-risk-monitoring-agent": "Third-Party Risk Monitoring Agent",
  "customer-360-agent": "Customer 360 Agent",
  "investment-diligence-agent": "Investment Diligence Agent",
  "marketing-agent": "Marketing Agent",
  "mr-insights-agent": "MR Insights Agent",
  "email-automation-agent": "Email Automation Agent",
  "qualitative-agent-v2": "Qualitative Agent - V2",
  "qualitative-agent-v3": "Qualitative Agent - V3",
  "quantitative-agent": "Quantitative Agent",
  "report-anything-agent": "Report Anything Agent",
  "whitepaper-generation-agent": "Whitepaper Generation Agent",

  "": "Company Diligence Agent",
};

const AiAgent = () => {
  const params = new URLSearchParams(window.location.search);
  const agent = params.get("agent");

  const { fetchListing } = useListing();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [thread_id, setthread_id] = useState("");
  const { Step, pitchdeck_data } = useAppSelector((state) => state.VSProduct);
  const firstRun = useRef(true);
  const userId = jsCookie.get("user_id");

  const [step, setStep] = useState(0);

  const [query, setQuery] = useState("");
  const [uploadStatus, setUploadStatus] = useState(false);
  const [answer, setanswer] = useState<string>("");
  const [attachedFile, setAttachedFile] = useState<File[] | null>(null);
  const [isfile, setFile] = useState<string>("");
  const chatRef = useRef<HTMLInputElement>(null);
  const [isLoading, setIsloading] = useState(false);
  const [isInitLoad, setIsInitLoad] = useState(false);
  const [delayLoading, setDelayLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [finalMessage, setFinalMessage] = useState(false);
  const [wireframeConfirmed, setWireframeConfirmed] = useState(false);
  const [contextPreview, setContextPreview] = useState(false);
  const [emailPreview, setEmailPreview] = useState(false)
  const [dataCollected, setDataCollected] = useState(false)
  const [paymentSuccessful, setPaymentSuccessful] = useState(false);
  const { chats } = useAppSelector((state) => state.VSProduct);
  // let { companyName } = useAppSelector((state) => state.VSProduct);
  const chatOptions = chats[chats.length - 1]?.options;

  useEffect(() => {
    scrollToBottom();
  }, [chats]);
  const [searchParams, setSearchParams] = useSearchParams();
  const threadId = searchParams.get("threadId");

  const updateUrlParam = (newKey: string, newValue: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set(newKey, newValue); // Add or update the search param
    setSearchParams(newParams);
  };

  const handleRenameThread = async (user_input: string) => {
    if (chats.length === 1) {
      const url = new URL(window.location.href);
      const searchParamsCurrent = new URLSearchParams(url.search);
      const threadIdCurrent = searchParamsCurrent.get("threadId");
      if (user_input) {
        const dynaminc = await fetch(
          `${API_PROD_URL}/agents/rename_thread/${userId}/${thread_id || threadId || threadIdCurrent || ""
          }?thread_name=${user_input
            .trim()
            .split(/\s+/)
            .slice(0, Math.min(3, user_input.trim().split(/\s+/).length))
            .join(" ")}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          },
        );
        if (dynaminc) {
          fetchListing && fetchListing();
        }
      }
    }
  };

  const initiateThreadChat = () => {
    setIsInitLoad(true);
    const fun = async () => {
      try {

        // Call API
        const createThreadResponse: any = await axios.post(
          `${API_PROD_URL}/agents/threads/create/?user_id=${userId || ""
          }&thread_name=${generateAgentThreadName(
            AgentName[agent || ""],
          )}&use_case=${agent === "investment-diligence-agent" ? "Help Sabancı Climate Ventures perform structured, intelligent due diligence on climate technology startups, with dynamic, context-aware guidance at each step" : "AI"}&industry=${agent === "investment-diligence-agent" ? "Climate Technology" : "AI"}&agent_name=${AgentName[agent || ""] || "Company Diligence Agent"
          }`,
          { headers: { "Content-Type": "application/json" }, responseType: "stream" },
        );

        const newTthreadRef =
          createThreadResponse.data.thread_id || generateAgentThreadName(AgentName[agent || ""]);

        const newParams = new URLSearchParams(searchParams);
        newParams.set("threadId", newTthreadRef); // Add or update the search param
        setSearchParams(newParams);
        setthread_id(newTthreadRef);

        // const id = generateKnowIdstring();
        // setthread_id(id);
        firstRun.current = true;

        const ai_query = {
          user_input: "",
          // answer == "Continue" && Step == 3 ? "how many question we want to answer" : answer,
          user_id: userId || "",
          thread_id:
            createThreadResponse.data.thread_id || generateAgentThreadName(AgentName[agent || ""]),
        };

        

        const { data } = agent === "quantitative-agent" ? await dispatch(
          initQuantChat(),
        ).unwrap() as any : await dispatch(
          sendAiAgentQuery({
            agentName: AgentName[agent || ""],
            ...ai_query,
            shouldRename: chats.length === 2,
            step,
          }),
        ).unwrap();

        if (data.type_json) {
          setJsonType(data.type_json);
        }
        if (data) {
          setStep(data?.step || step + 1);
        }

        const { options, remainingText } = processResponse(data.response, agent);
        dispatch(
          setVSChats({
            query: remainingText,
            answer: "",
            options: options || [],
            hasbutton: !!options?.length,
          }),
        );
      } catch (error) {
        handleApiError();
        console.log(error);
      } finally {
        setQuery(""); // Clear input field
        setIsloading(false);
        setIsInitLoad(false);
      }
    };
    fun();
  };

  useEffect(() => {
    setIsloading(true);

    if (threadId) {
      dispatch(resetChats());
      setthread_id(threadId);
      fetchAgentThreadDetails(threadId || "", userId || "", agent || "", (response) => {
        setIsloading(false);
        response.reports?.conversations
          ?.sort((a: any, b: any) => {
            const dateA = a.id;
            const dateB = b.id;
            return dateA - dateB; // Descending order
          })
          ?.map((report: any) => {
            const { options, remainingText } = processResponse(report.user_message || "", agent);
            const { options: optionAnswer, remainingText: remainingTextAnswer } = processResponse(
              report.assistant_message || "",
              agent
            );

            if (remainingText) {
              if (remainingText.includes("pitchdeck_summary")) {
                dispatch(
                  setVSChats({
                    query: report.user_message,
                    answer: "",
                    extract: report.user_message,
                    extractObject: report.json_report,
                    options: options || [],
                    hasbutton: !!options?.length,
                    json_report: report.json_report,
                    json_datasources: report.json_datasources,
                  }),
                );
                dispatch(updatePitchdeckData({ pitchdeckSummary: remainingText }));
              } else {
                dispatch(
                  setVSChats({
                    query: "",
                    answer: remainingText,
                    options: [],
                    hasbutton: false,
                    json_report: report.json_report,
                    json_datasources: report.json_datasources,
                  }),
                );
              }
            }
            if (remainingTextAnswer) {
              dispatch(
                setVSChats({
                  query: remainingTextAnswer,
                  answer: "",
                  options: optionAnswer,
                  hasbutton: !!optionAnswer.length || false,
                  json_report: report.json_report,
                  json_datasources: report.json_datasources,
                }),
              );
            }
            // dispatch(
            //   setVSChats({
            //     query: remainingText,
            //     answer: "",
            //     options: options || [],
            //     hasbutton: !!options?.length,
            //   }),
            // );
          });
      });
    } else {
      dispatch(resetChats());
      // if(agent==="customer-360-agent"){
      //   setIsloading(false)
      //    setCustStep(6);
      //   const step2 = initStep1;
      //   dispatch(
      //     setVSChats({
      //       query: step2.prompt,
      //       answer: "",
      //       options: [],
      //       hasbutton: false,
      //     }),
      //   );
      // }
      // else{
      initiateThreadChat();
      // }
    }
    // setFile("false");
  }, [threadId]);

  const scrollToBottom = () => {
    if (chatRef.current) {
      chatRef.current.scrollTo({
        top: chatRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const [jsonResponse, setJsonResponse] = useState<any>(null);
  const [connectorInput, setConnectorInput] = useState<any>(null);
  const [updatedJson, setUpdatedJson] = useState<any>(null);

  const [jsonType, setJsonType] = useState<string>("");

  const [dataSources, setDataSources] = useState<any>(null);

  const updateVsChat = (payload: { query: string; answer: string; isError?: boolean }) => {
    dispatch(setVSChats(payload));
  };

  const [uploadingfile, setUplaodingFile] = useState(false);
  const [analysingfile, setAnalysingFile] = useState(false);
  const [chatEnded, setChatEnded] = useState(false);

  const apiResponseError = "Something went wrong on our side. We're working to fix it.";

  const handleApiError = () => {
    updateVsChat({
      query: apiResponseError,
      answer: "",
      isError: true,
    });
  };

  const isWireframeConfirmationRequired = () => {
    return jsonType === "newsletter_agent_wireframe" && !wireframeConfirmed;
  };

  const isContextPreviewed = () => {
    return jsonType === "newsletter_agent_context_preview" && !contextPreview;
  }

  const isEmailPreviewed = () => {
    return jsonType === "newsletter_agent_email_layout" && !emailPreview;
  }

  const isDataCollected = () => {
    return jsonType === "newsletter_agent_data_collection" && !dataCollected;
  }

  // Add this useEffect in your AiAgent component
  useEffect(() => {
    if (jsonType !== "newsletter_agent_wireframe") {
      setWireframeConfirmed(false);
    }

    if (jsonType !== "newsletter_agent_context_preview") {
      setContextPreview(false);
    }

    if (jsonType !== "newsletter_agent_email_layout") {
      setEmailPreview(false);
    }

    if (jsonType !== "newsletter_agent_data_collection") {
      setDataCollected(false);
    }
  }, [jsonType]);
  const isExcel = (file: File) => {
    const excelMimeTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    const excelExtensions = [".csv", ".xls", ".xlsx"];

    return (
      excelMimeTypes.includes(file.type) ||
      excelExtensions.some(ext => file.name.toLowerCase().endsWith(ext))
    );
  };

  const handleFileSubmitQuery = async (file: File[]) => {
    const url = new URL(window.location.href);
    const searchParamsCurrent = new URLSearchParams(url.search);
    const threadIdCurrent = searchParamsCurrent.get("threadId");
    const errorUploadingFile =
      "Hmm, I couldn’t process that file. It may be in the wrong format or corrupted. Could you try again or try uploading a different one?";

    const newQueryIndex = generateKnowId();
    const firstQuery = {
      id: newQueryIndex,
      query: "Great! Let me deep dive into the file.",
      answer: file.map((ele) => ele.name).join("____file____"),
      isFile: true,
      file: file,
    };

    const handleFileUploadError = () => {
      updateVsChat({
        query: errorUploadingFile,
        answer: "",
        isError: true,
      });
    };
    setTimeout(() => {
      dispatch(setVSChats(firstQuery));
      dispatch(setCurrentStep(1));
    }, 1000);
    setUplaodingFile(true);
    setShowFiles(file);

    if (agent === "quantitative-agent") {
      const files = Array.from(file || []);

      const excel_file = files.find(isExcel);
      const guide_file = files.find(f => !isExcel(f));
      const pptResp = await dispatch(quantAgnetUploadFiles({
        user_id: userId || "",
        thread_id: thread_id || threadId || threadIdCurrent || "",
        excel_file: excel_file as File,
        guide_file: guide_file as File,
      })).unwrap();

      if (pptResp) {
        setUplaodingFile(false);
        setIsloading(false);
        setJsonType(pptResp?.type_json)
        setJsonResponse(pptResp?.json_response)
        const { remainingText } = processResponse(pptResp.response, agent);

        const dynaminc = await dispatch(
          dynamicThreadName({
            fileData: pptResp?.json_response,
            userId: userId || "",
            threadId: thread_id || threadId || threadIdCurrent || "",
          }),
        ).unwrap();
        if (dynaminc) {
          fetchListing && fetchListing();
        }

        dispatch(
          setVSChats({
            query: remainingText,
            answer: "",
          }),
        );
      }
      return
    }

    const pptResp = await dispatch(extractFileData(file)).unwrap();
    const fileResponse = pptResp?.fileData;
    const dynaminc = await dispatch(
      dynamicThreadName({
        fileData: fileResponse,
        userId: userId || "",
        threadId: thread_id || threadId || threadIdCurrent || "",
      }),
    ).unwrap();
    if (dynaminc) {
      fetchListing && fetchListing();
    }
    if (fileResponse) {
      setUplaodingFile(false);
      setIsloading(true);
      try {
        setAnalysingFile(true);
        handleSendQuery("", "Looks good", undefined, undefined, true);
        setUploadStatus(false);
      } catch (error) {
        handleFileUploadError();
      }
    } else {
      setIsloading(false);
      setUplaodingFile(true);
      handleFileUploadError();
    }
  };

  const checkIfFileUpload = (response: string) => {
    if (
      response?.includes("upload the pitch deck") ||
      response?.includes(" upload your pitch deck") ||
      response?.includes(" upload a pitch deck")
    ) {
      setUploadStatus(true);
    } else {
      setUploadStatus(false);
    }
  };

  const processStatusMain = (data: any) => {
    const cleanedSummary = data.json_response;
    // const cleanValue = data.json_response?.replace(/'/g, '"');
    const extractObject = data.json_response;
    const { options, remainingText } = processResponse(data.response, agent);
    dispatch(
      setVSChats({
        query: remainingText,
        answer: "",
        extract: cleanedSummary,
        extractObject,
        options: options || [],
        hasbutton: !!options?.length,
      }),
    );
    dispatch(
      setVSChats({
        query: "",
        answer: "",
        options: ["Edit Summary", "Looks good"],
        hasbutton: true,
      }),
    );
  };

  const lastCallParams = useRef<{
    query: string;
    answer: string;
    file?: File[];
    button?: boolean;
    shouldSentPitch?: boolean;
  } | null>(null);

  const handleRetry = () => {
    if (lastCallParams.current) {
      const { query, answer, file, button, shouldSentPitch } = lastCallParams.current;
      handleSendQuery(query, answer, file, button, shouldSentPitch);
    }
  };

  const [showFiles, setShowFiles] = useState<File[]>([]);
  const [mappedSelectedFile, setMappedSelectedFile] = useState<File>();

  const [prevQuery, setPrevQuery] = useState<any>(null);
  const sendInputQuery = (jsonResponse: any) => {
    dispatch(interactiveReportInput({
      template_json: JSON.stringify(jsonResponse), userId: String(userId), // Convert userId to string
      threadId: String(thread_id),
      use_case: AgentName[agent || ""] === "Investment Diligence Agent" ? "investment_due_diligence" : agent === "report-anything-agent" ? "report_on_anything" : "customer_360_intelligence",
      user_files: showFiles
    }))
      .unwrap()
      .catch((err: any) => {
        console.error("interactiveReportInput failed", err);
      });
  }

  const handleSendQuery = useCallback(
    async (
      query: string,
      answer: string,
      file?: File[],
      button?: boolean,
      shouldSentPitch?: boolean,
    ) => {
      if (custOpt) {
        setPrevQuery({
          query,
          answer,
          file,
          button,
          shouldSentPitch,
        });
        updateCustStep();
        return;
      }

      setIsloading(true);
      lastCallParams.current = { query, answer, file, button, shouldSentPitch };
      const url = new URL(window.location.href);
      const searchParamsCurrent = new URLSearchParams(url.search);
      const threadIdCurrent = searchParamsCurrent.get("threadId");
      const newQueryIndex = generateKnowId();
      try {
        setJsonResponse(null);
        setConnectorInput(null);
        setJsonType("");
        setDataSources(null);
        setanswer("");
        if (file?.length) {
          handleFileSubmitQuery(file);
        } else {
          if (answer === "Go Home") {
            dispatch(resetChats());
            setthread_id(generateAgentThreadName(AgentName[agent || ""]));
            firstRun.current = true;
            setFile("false");
            navigate("/", {
              replace: true,
            });
            return;
          }
          if (answer === "Start another report") {
            dispatch(resetChats());
            setthread_id(generateAgentThreadName(AgentName[agent || ""]));
            firstRun.current = true;
            setFile("false");
            return;
          }
          const ai_query = {
            user_input: answer,
            // answer == "Continue" && Step == 3 ? "how many question we want to answer" : answer,
            user_id: userId || "",
            thread_id: thread_id || threadIdCurrent || "",
            button: button,
          };

          //
          if (button) {
            if (answer !== "Edit Summary") {
              dispatch(updateButtonSelection({ hasselected: true }));
            }
            dispatch(setprevres({ answer }));

            switch (answer) {
              case "End Conversation":
                ai_query.user_input = "chat_ended";
                setChatEnded(true);
                try {
                  const { data } = await dispatch(
                    sendAiAgentQuery({
                      agentName: AgentName[agent || ""],
                      ...ai_query,
                      sendPitchData: shouldSentPitch ? true : false,
                      step,
                      // file_upload_status: true,
                      jsonType,
                    }),
                  ).unwrap();
                  if (data) {
                    setStep(data?.step || step + 1);
                  }

                  const endedResponse = await dispatch(
                    endChatThread({
                      thread_id: thread_id,
                      user_id: userId || "",
                    }),
                  );
                  if (endedResponse && fetchListing) {
                    fetchListing();
                  }
                  let convoOptions: string[] = [];
                  const { options, remainingText } = processResponse(data.response, agent);
                  if (data.response?.toLowerCase().includes("24-48 hours")) {
                    convoOptions = ["End Conversation"];
                    // updateUrlParam("side", "false");
                  }
                  const userOptions = options?.length
                    ? options
                    : convoOptions.length
                      ? convoOptions
                      : [];
                  dispatch(
                    setVSChats({
                      query: remainingText,
                      answer: "",
                      options: userOptions,
                      hasbutton: !!userOptions?.length,
                    }),
                  );
                } finally {
                  setIsloading(false);
                }
                break;

              case "Looks good":
                ai_query.user_input = "Looks good";
                setIsloading(true);
                try {
                  const { data } = await dispatch(
                    sendAiAgentQuery({
                      agentName: AgentName[agent || ""],
                      ...ai_query,
                      sendPitchData: shouldSentPitch ? true : false,
                      step,
                      jsonType,
                      // file_upload_status: true,
                    }),
                  ).unwrap();

                  if (data) {
                    setStep(data?.step || step + 1);
                  }

                  if (
                    data?.response?.includes("upload the pitch deck") ||
                    data?.response?.includes("upload your pitch deck") ||
                    data?.response?.includes("upload a pitch deck")
                  ) {
                    setUploadStatus(true);
                  }

                  let convoOptions: string[] = [];
                  const json_response = data.json_response;
                  setJsonResponse(json_response);
                  setConnectorInput(data)
                  if (data.type_json) {
                    updateUrlParam("side", "false");
                  }
                  try {
                    if (data.type_json === "Data_sources") {
                      setJsonType(data.type_json);
                      if (json_response?.["External sources"]) {
                        setDataSources(json_response);
                      } else {
                        setDataSources(JSON.parse(json_response));
                      }
                    } else {
                      if (data.response?.toLowerCase().includes("24-48 hours")) {
                        convoOptions = ["End Conversation"];
                      }
                      if (data.type_json) {
                        updateUrlParam("side", "false");
                      }
                      setJsonType(data.type_json);
                    }
                    if (json_response?.keywords) {
                      setJsonType("keywords");
                    }
                  } catch (error) {
                    handleApiError();
                    if (data.response?.toLowerCase().includes("24-48 hours")) {
                      convoOptions = ["End Conversation"];
                      updateUrlParam("side", "false");
                    }
                    setJsonType(data.type_json);
                    setJsonResponse(json_response);
                    setConnectorInput(data)
                    if (json_response?.keywords) {
                      setJsonType("keywords");
                      updateUrlParam("side", "false");
                    }
                  }

                  const { options, remainingText } = processResponse(data.response, agent);
                  dispatch(
                    setVSChats({
                      query: remainingText,
                      answer: "",
                      options: options || [],
                      hasbutton: !!options?.length,
                    }),
                  );

                  if (data.type_json === "Data_sources") {
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "Final_report" ||
                    data.response?.toLowerCase().includes("24-48 hours")
                  ) {
                    sendInputQuery(data.json_response);
                    // json_response
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  }else if (data.type_json === "report_on_anything_agent_v3_report_template") {
                  sendInputQuery(data.json_response);
                  // Don't add Submit button here - it will be shown after payment
                  } else if (
                    data.type_json === "campaign_template" ||
                    data.response?.toLowerCase().includes("24-48 hours")
                  ) {
                    // sendInputQuery(data.json_response);
                    // json_response
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (
                    data.type_json === "connector_input" ||
                    data.response?.toLowerCase().includes("24-48 hours")
                  ) {
                    // sendInputQuery(data.json_response);
                    // json_response
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (
                    data.type_json === "insights_adoption_agent"
                  ) {
                    // sendInputQuery(data.json_response);
                    // json_response
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (
                    data.type_json === "report_generation_adoption_agent"
                  ) {
                    // sendInputQuery(data.json_response);
                    // json_response
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_wireframe"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_context_preview"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_email_layout"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_data_collection"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "whitepaper_agent_v1_whitepaper_generated"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Open Report"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (
                    data.type_json === "whitepaper_agent_v1_table_of_contents"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  }else if (
                  data.type_json === "report_on_anything_agent_v2_final_summary"  
                ) {
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                }
                } finally {
                  setIsloading(false);
                  setAnalysingFile(false);
                }
                break;

              case "Open Report": {
                handleOpenReport();
                setIsloading(false);
                break;
              }

              case "Try Again": {
                handleOpenReport();
                setIsloading(false);
                break;
              }

              case "Edit Summary":
                setModalOpen(true);
                setIsloading(false);
                return;

              default:
                ai_query.user_input = answer === "Next Step" ? "proceed further" : answer;
                setIsloading(true);
                try {
                  const { data } = await dispatch(
                    sendAiAgentQuery({
                      agentName: AgentName[agent || ""],
                      ...ai_query,
                      sendPitchData: shouldSentPitch ? true : false,
                      step,
                      jsonType,
                      // file_upload_status: true,
                    }),
                  ).unwrap();

                  if (data) {
                    setStep(data?.step || step + 1);
                  }

                  if (
                    data?.response?.includes("upload the pitch deck") ||
                    data?.response?.includes("upload your pitch deck") ||
                    data?.response?.includes("upload a pitch deck")
                  ) {
                    setUploadStatus(true);
                  }

                  const { options, remainingText } = processResponse(data.response, agent);
                  const json_response = data.json_response;

                  let convoOptions: string[] = [];
                  try {
                    setJsonResponse(json_response);
                    setConnectorInput(data)
                    if (data.type_json) {
                      updateUrlParam("side", "false");
                    }
                    if (data.type_json === "Data_sources") {
                      setJsonType(data.type_json);
                      if (json_response?.["External sources"]) {
                        setDataSources(json_response);
                      } else {
                        setDataSources(JSON.parse(json_response));
                      }
                    } else {
                      if (data.response?.toLowerCase().includes("24-48 hours")) {
                        convoOptions = ["End Conversation"];
                      }
                      setJsonType(data.type_json);
                      setJsonResponse(json_response);
                      setConnectorInput(data)
                    }
                    if (json_response?.keywords) {
                      setJsonType("keywords");
                    }
                  } catch (error) {
                    handleApiError();
                    if (data.response?.toLowerCase().includes("24-48 hours")) {
                      convoOptions = ["End Conversation"];
                    }
                    setJsonType(data.type_json);
                    setJsonResponse(json_response);
                    setConnectorInput(data)
                    if (json_response?.keywords) {
                      setJsonType("keywords");
                    }
                  }
                  const userOptions = options?.length
                    ? options
                    : convoOptions.length
                      ? convoOptions
                      : [];
                  dispatch(
                    setVSChats({
                      query: remainingText,
                      answer: "",
                      options: userOptions,
                      hasbutton: !!userOptions?.length,
                    }),
                  );
                  setJsonType(data.type_json);
                  if (data.type_json === "Data_sources") {
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  } else if (data.type_json === "Final_report") {
                    sendInputQuery(data.json_response);
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  }else if (data.type_json === "report_on_anything_agent_v3_report_template") {
                  sendInputQuery(data.json_response);
                  // Don't add Submit button here - it will be shown after payment
                  } else if (data.type_json === "campaign_template") {
                    // sendInputQuery(data.json_response);
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (data.type_json === "connector_input") {
                    // sendInputQuery(data.json_response);
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  }
                  else if (
                    data.type_json === "insights_adoption_agent"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  }

                  else if (
                    data.type_json === "report_generation_adoption_agent"
                  ) {

                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Submit"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_wireframe"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_context_preview"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_email_layout"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "newsletter_agent_data_collection"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Next Step"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "whitepaper_agent_v1_whitepaper_generated"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Open Report"],
                        hasbutton: true,
                      }),
                    );
                  } else if (
                    data.type_json === "whitepaper_agent_v1_table_of_contents"
                  ) {
                   
                    dispatch(
                      setVSChats({
                        query: "",
                        answer: "",
                        options: ["Continue"],
                        hasbutton: true,
                      }),
                    );
                  }else if (
                  data.type_json === "report_on_anything_agent_v2_final_summary"  
                ) {
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                }
                } finally {
                  setIsloading(false);
                  setAnalysingFile(false);
                }
                break;
            }
          }

          //
          else {
            if (answer === "Looks good") {
              //** Fifth Converstaion **//
              ai_query.user_input = "Looks good";
              const { data } = await dispatch(
                sendAiAgentQuery({
                  agentName: AgentName[agent || ""],
                  ...ai_query,
                  sendPitchData: true,
                  file_upload_status: true,
                  step,
                  jsonType,
                }),
              ).unwrap();
              if (data) {
                setStep(data?.step || step + 1);
              }
              handleRenameThread(answer);
              if (data) {
                setIsloading(false);
                setAnalysingFile(false);
                const json_response = data.json_response;
                setJsonResponse(json_response);
                setConnectorInput(data)
                if (data.type_json) {
                  updateUrlParam("side", "false");
                }
                setJsonType(data.type_json);
              }
              checkIfFileUpload(data?.response);

              if (data.status_main && agent !== "prior-art-agent") {
                processStatusMain(data);
              } else {
                if (agent === "customer-360-agent" || agent === "investment-diligence-agent" || agent === "marketing-agent") {
                  setCustOpt(true);
                  setCustStep(2);
                  const step1 = custStep1;
                  setJsonType("Auto_mapper_field");
                  dispatch(
                    setVSChats({
                      query: step1.prompt,
                      answer: step1.prompt,
                      options: ["Next Step"],
                      hasbutton: true,
                    }),
                  );
                } else {
                  const { options, remainingText } = processResponse(data.response, agent);
                  dispatch(
                    setVSChats({
                      query: remainingText,
                      answer: "",
                      options: options || [],
                      hasbutton: !!options?.length,
                    }),
                  );
                }
              }
              // dispatch(setVSChats({ query: data?.response, answer: answer }));
              //**     **//
            } else {
              dispatch(
                setVSChats({
                  query: "",
                  answer: answer,
                  hasbutton: false,
                }),
              );
              const { data } = await dispatch(
                sendAiAgentQuery({
                  agentName: AgentName[agent || ""],
                  ...ai_query,
                  sendPitchData: shouldSentPitch ? true : false,
                  step,
                  jsonType,
                  // sendPitchData: !!Object.keys(dataSources || {}).length,
                }),
              ).unwrap();
              if (data) {
                setStep(data?.step || step + 1);
              }
              handleRenameThread(answer);
              if (data) {
                setIsloading(false);
                setJsonType(data.type_json);
              }
              setJsonResponse(data.json_response);
              setConnectorInput(data)
              if (data.type_json) {
                updateUrlParam("side", "false");
              }
              if (data.status_main && agent !== "prior-art-agent") {
                processStatusMain(data);
              } else {
                checkIfFileUpload(data?.response);
                const { options, remainingText } = processResponse(data.response, agent);
                const json_response = data.json_response;

                // if (
                //   remainingText.includes("Critical Questions") &&
                //   agent === "customer-360-agent"
                // ) {
                //   setCustOpt(true);
                //   setCustStep(1);
                // }


                let convoOptions: string[] = [];
                try {
                  if (data.type_json === "Data_sources") {
                    if (json_response?.["External sources"]) {
                      setDataSources(json_response);
                    } else {
                      setDataSources(JSON.parse(json_response));
                    }
                    updateUrlParam("side", "false");
                  } else {
                    if (data.response?.toLowerCase().includes("24-48 hours")) {
                      convoOptions = ["End Conversation"];
                      updateUrlParam("side", "false");
                    }
                    setJsonType(data.type_json);
                    if (json_response?.keywords) {
                      setJsonType("keywords");

                      updateUrlParam("side", "false");
                    }

                    // setJsonResponse({
                    //   keywords: ["connected packaging", "hassle free"],
                    // });
                    setJsonResponse(json_response);
                    setConnectorInput(data)
                  }
                } catch (error) {
                  handleApiError();
                  if (data.response?.toLowerCase().includes("24-48 hours")) {
                    convoOptions = ["End Conversation"];
                    updateUrlParam("side", "false");
                  }
                  setJsonType(data.type_json);
                  setJsonResponse(json_response);
                  setConnectorInput(data)
                  if (json_response?.keywords) {
                    setJsonType("keywords");
                    updateUrlParam("side", "false");
                  }
                }

                dispatch(
                  setVSChats({
                    query: remainingText,
                    answer: "",

                    hasbutton: false,
                  }),
                );
                const userOptions = options?.length
                  ? options
                  : convoOptions.length
                    ? convoOptions
                    : [];
                dispatch(
                  setVSChats({
                    query: "",
                    answer: "",
                    options: userOptions,
                    hasbutton: !!userOptions?.length,
                  }),
                );
                if (data.type_json === "Data_sources") {
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Next Step"],
                      hasbutton: true,
                    }),
                  );
                } else if (data.type_json === "Final_report") { 
                  sendInputQuery(data.json_response);
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Submit"],
                      hasbutton: true,
                    }),
                  );
                } else if (data.type_json === "report_on_anything_agent_v3_report_template") {
                  sendInputQuery(data.json_response);
                  // Don't add Submit button here - it will be shown after payment
                } else if (data.type_json === "campaign_template") {
                  // sendInputQuery(data.json_response);
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Submit"],
                      hasbutton: true,
                    }),
                  );
                } else if (data.type_json === "connector_input") {
                  // sendInputQuery(data.json_response);
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Next Step"],
                      hasbutton: true,
                    }),
                  );
                }
                else if (
                  data.type_json === "insights_adoption_agent"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                } else if (data.type_json === "report_generation_adoption_agent") {
                  // sendInputQuery(data.json_response);
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Submit"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "newsletter_agent_wireframe"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "newsletter_agent_context_preview"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "newsletter_agent_email_layout"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "newsletter_agent_data_collection"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Next Step"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "whitepaper_agent_v1_whitepaper_generated"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Open Report"],
                      hasbutton: true,
                    }),
                  );
                } else if (
                  data.type_json === "whitepaper_agent_v1_table_of_contents"
                ) {
                 
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                }else if (
                  data.type_json === "report_on_anything_agent_v2_final_summary"  
                ) {
                  dispatch(
                    setVSChats({
                      query: "",
                      answer: "",
                      options: ["Continue"],
                      hasbutton: true,
                    }),
                  );
                }
              }
            }
          }
        }
        // dispatch(setVSChats({ query: response?.response, answer: query }));
      } catch (error) {
        handleApiError();
        setIsloading(false);
        console.error("Error fetching API response:", error);
      } finally {
        setQuery(""); // Clear input field
        // setIsloading(false);
      }
    },
    [dispatch, query, answer, handleFileSubmitQuery, jsonType],
  );

  const accessToken = jsCookie.get("pn_refresh");

  const [custOpt, setCustOpt] = useState(false);
  const [custStep, setCustStep] = useState(2);


  const updateCustStep = () => {
    setanswer("");
    switch (custStep) {
      case 1:
        {
          setCustStep(2);
          const step1 = custStep1;
          setJsonType("Auto_mapper_field");
          dispatch(
            setVSChats({
              query: step1.prompt,
              answer: step1.prompt,
              options: ["Next Step"],
              hasbutton: true,
            }),
          );
        }
        break;
      case 2:
        {
          setCustStep(1);
          const step2 = custStep2;
          setJsonType("checklist");
          setCustOpt(false);
          dispatch(
            setVSChats({
              query: step2.prompt,
              answer: step2.prompt,
              options: ["Next Step"],
              hasbutton: true,
            }),
          );
        }
        break;
      case 3:
        {
          setCustStep(1);
          setCustOpt(false);
          const step2 = custStep4;
          setJsonType("auto_filled_summary");
          dispatch(
            setVSChats({
              query: step2.prompt,
              answer: step2.prompt,
              options: ["Next Step"],
              hasbutton: true,
            }),
          );
        }
        break;
      /*case 4: {
        setCustStep(1);
        setCustOpt(false);
        const step2 = custStep4;
        setJsonType("summary_panel");
        dispatch(
          setVSChats({
            query: step2.prompt,
            answer: step2.prompt,
            options: ["Next Step"],
            hasbutton: true,
          }),
        );
      }
      break*/
      case 6: {
        setCustStep(7);
        const step2 = initStep2;
        const prompts: any = {
          "Retail Banking": `Great! Can you also specify the sub-industry or business unit you work in?\ne.g.,Affluent Customer Banking, Digital Onboarding, Personal Loan Automation`,
          "Grocery Retail": `And which customer types or departments are most strategic for your current analysis?
          \ne.g.,Private-label buyers,” “Health-conscious professionals,” “Online-only shoppers,” “Coupon-sensitive households,” “Urban weekend shoppers`,
          "B2B SaaS": `And what use cases or client teams are you most focused on improving?
   \ne.g. Internal Comms at global HQs, L&D departments with poor completion rates, Renewal-blocking disengagement, Reactivating APAC region.`
        }
        dispatch(
          setVSChats({
            query: prompts[answer] || prompts["Retail Banking"],
            answer: answer,
            options: [],
            hasbutton: false,
          }),
        );
      }
        break
      case 7: {
        setCustStep(1);
        setCustOpt(false)
        initiateThreadChat()
      }
    }

  };

  const handleCampaignSave = (updatedData: any) => {
    
    // ✅ now you can use updatedData here, save to DB, set state, etc.
    setUpdatedJson(updatedData);
  };

  const handleOpenReport = () => {
    if (jsonType === "whitepaper_agent_v1_whitepaper_generated" && jsonResponse) {
      try {
        // Store in sessionStorage first
        sessionStorage.setItem('whitepaper_report', JSON.stringify({
          response: jsonResponse,
          threadId: thread_id || threadId,
          userId: userId,
          timestamp: Date.now()
        }));
        navigate("/whitepaper-report");
      } catch (error) {
        console.error("Error opening report:", error);
      }
    }
  };

  useEffect(() => {
    if (jsonType !== "report_on_anything_agent_v3_report_template") {
      setPaymentSuccessful(false);
    }
  }, [jsonType]);

  // ✅ Handler when payment succeeds - adds Submit button
  const handlePaymentSuccess = async () => {
    setPaymentSuccessful(true);
    await toast.success("Payment completed successfully");
    // Add the Submit button to the chat
    dispatch(
      setVSChats({
        query: "",
        answer: "",
        options: ["Submit"],
        hasbutton: true,
      }),
    );
  };

  return (
    <>
      <div className="px-0 md:px-3 w-full mx-auto h-full">
        <div className="flex justify-between items-start">
          {accessToken ? (
            <div className="inline-flex justify-start items-center mt-2 mb-2 flex-0">
              <Link to="/ai-agent/landing">
                <p className="mr-4 text-secondary-800 flex items-center min-h-4">
                  <ArrowLeftIcon className="mr-1" />
                  Back
                </p>
              </Link>
            </div>
          ) : null}
          <AgentHead
            agentName={AgentName[agent || ""] || "Company Diligence Agent"}
            hideMenu={!accessToken}
            className="flex-1"
          />
        </div>
        <div className="flex flex-col gap-y-3 lg:flex-row lg:gap-y-0 gap-x-5 lg:gap-x-2">
          {((AgentName[agent || ""] == "Qualitative Agent - V2") || (AgentName[agent || ""] == "Qualitative Agent - V3")) && <div className="">
            <AgentInfo agent={agent} />
          </div>}
          <div className="flex-auto relative flex flex-col gap-2 max-w-[780px] mx-auto min-h-[100vh]">
            {/* <div className="relative flex-none">
              <div className="absolute left-[-25px] md:left-[-40px] lg:left-[-45px] top-2 w-[10px]">
                <StepBar />
              </div>
            </div> */}

            {chatEnded ? (
              <div className="flex flex-row justify-between flex-auto">
                <ReportDefault
                  finalMessage={chatEnded}
                  setFinalMessage={() => {
                    setChatEnded(false);
                  }}
                />
              </div>
            ) : (
              <div className="flex flex-row flex-auto justify-center">
                <div
                  ref={chatRef}
                  className="bg-white rounded-lg p-3 pt-0 w-full max-h-[calc(100vh-244px)] overflow-y-auto pn_scroller shadow-[0_4px_4px_0] shadow-[#000]/[0.06]"
                >
                  <div className="">
                    {chats.map((chat: any, idx) => {
                      const currentHasDataSource =
                        !!chat.json_datasources && Object.keys(chat.json_datasources).length > 0;
                      const nextHasDataSource =
                        !!chats[idx + 1]?.json_datasources &&
                        Object.keys(chats[idx + 1].json_datasources).length > 0;

                      const shouldRenderCombinedDataSources =
                        currentHasDataSource && nextHasDataSource;

                      const shouldRenderSingleDataSource =
                        currentHasDataSource && !nextHasDataSource;

                      const currentHasJsonReport =
                        !!chat.json_report &&
                        Object.keys(chat.json_report || {})?.[0]?.toLowerCase() === "sections";
                      const nextHasJsonReport =
                        !!chats[idx + 1]?.json_report &&
                        Object.keys(chats[idx + 1].json_report || {})?.[0]
                          ?.toLowerCase()
                          ?.includes("new");
                      const shouldRenderCombinedJsonReport =
                        currentHasJsonReport && nextHasJsonReport;
                      const shouldRenderSingleJsonReport =
                        currentHasJsonReport && !nextHasJsonReport;
                      return (
                        <>
                          {chat.options?.length ? (
                            <ChatQuery
                              query={chat.query}
                              index={idx}
                              initLoading={isInitLoad}
                              agentName={AgentName[agent || ""]}
                              isError={chat.isError}
                              retry={handleRetry}
                              updateUserInput={(value: string) => {
                                setanswer(`${query} ${value}`);
                              }}
                              answer={answer}
                            />
                          ) : null}
                          <QueryAnswer
                            index={idx}
                            initLoading={isInitLoad}
                            ido={`chat-[${idx}]`}
                            query={chat.query}
                            answer={chat.answer || ""}
                            isLoading={isLoading}
                            setanswer={setanswer}
                            message_id={chat.id || 0}
                            options={chat.options}
                            hasselected={chat.hasselected || false}
                            hasbutton={chat.hasbutton || false}
                            onSendQuery={handleSendQuery}
                            file={chat.file}
                            threadId={thread_id}
                            agent={agent}
                            jsonResponse={agent === 'marketing-agent' ? updatedJson : jsonResponse}
                            isButtonDisabled={isWireframeConfirmationRequired() || isContextPreviewed() || isEmailPreviewed() || isDataCollected()}
                          />
                          {isLoading}

                          {chat.extract ? (
                            <ExtractInfo
                              onSendQuery={handleSendQuery}
                              modalOpen={modalOpen}
                              setModalOpen={setModalOpen}
                              info={chat.extract}
                              query={chat.query}
                              obj={chat.extractObject}
                            />
                          ) : !chat.options?.length ? (
                            <ChatQuery
                              query={chat.query}
                              index={idx}
                              initLoading={isInitLoad}
                              agentName={AgentName[agent || ""]}
                              isError={chat.isError}
                              dataSource={chat.json_datasources || {}}
                              additionalDataSources={
                                shouldRenderCombinedDataSources
                                  ? chats[idx + 1]?.json_datasources || {}
                                  : {}
                              }
                              updateUserInput={(value: string) => {
                                setanswer(`${value}`);
                              }}
                              answer={answer}
                              // json_report={
                              //   Object.keys(chat?.json_report || {})?.[0]?.toLowerCase() ===
                              //   "sections"
                              //     ? chat.json_report
                              //     : {}
                              // }
                              json_report={
                                shouldRenderCombinedJsonReport || shouldRenderSingleJsonReport
                                  ? chat.json_report
                                  : {}
                              }
                              additionalJsonReport={
                                shouldRenderCombinedJsonReport
                                  ? chats[idx + 1]?.json_report || {}
                                  : {}
                              }
                              // dataSource={chat.json_datasources || {}}
                              retry={handleRetry}
                            />
                          ) : null}
                        </>
                      );
                    })}
                    {/* ✅ Only show Stripe button when json type matches and payment not successful yet */}
                    {jsonType === "report_on_anything_agent_v3_report_template" && !paymentSuccessful && (
                      <div className="flex flex-wrap items-center justify-end mt-2">
                        <StripeConnect 
                          pipelineTriggerFn={() => sendInputQuery(jsonResponse)} 
                          onPaymentSuccess={handlePaymentSuccess}
                        />
                      </div>
                    )}
                    {delayLoading && (
                      <div className="flex items-center justify-center p-5 h-full">
                        <DotLoader />
                      </div>
                    )}
                    {uploadingfile || analysingfile ? (
                      <LoadingUI uploadingFile={uploadingfile} analyzing={analysingfile} />
                    ) : isInitLoad ? (
                      <div className="flex items-center justify-center p-5 h-full">
                        <DiligenceAgentThinking
                          agentName={AgentName[agent || ""]}
                          loading={isInitLoad}
                        />
                      </div>
                    ) : (
                      isLoading && (
                        <div className="flex items-center justify-center p-5 h-full">
                          <DotLoader />
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}

            <div className="flex items-center justify-center mt-auto">
              <AddQueryAgent
                setanswer={setanswer}
                query={query}
                answer={answer}
                uploadStatus={
                  custOpt ? false :
                    agent === "prosecution-history-agent"
                      ? false
                      : uploadStatus ||
                      chats?.[chats?.length - 1]?.query
                        ?.toLowerCase()
                        ?.includes("upload the pitch deck") ||
                      chats?.[chats?.length - 1]?.query
                        ?.toLowerCase()
                        ?.includes("upload your pitch deck") ||
                      chats?.[chats?.length - 1]?.query
                        ?.toLowerCase()
                        ?.includes("upload a pitch deck") ||
                      chats?.[chats?.length - 1]?.query
                        ?.toLowerCase()
                        ?.includes("upload their pitch deck")
                }
                setFile={setAttachedFile}
                // sendQuery={() => {
                //   fetchResponse(query);
                // }}
                fileRequired={
                  custOpt ? true :
                    !agent ||
                    agent === "company-diligence-agent" ||
                    agent === "prosecution-history-agent" || agent === "marketing-agent"
                }
                sendQuery={handleSendQuery}
                allDisabled={chats?.filter((chat) => chat.answer === "chat_ended")?.length > 0 || isWireframeConfirmationRequired() || isContextPreviewed() || isEmailPreviewed() || isDataCollected()}
              />
            </div>
          </div>

          {/* {Step === 4 && SidescreenOptions && SidescreenOptions.length > 0 && <InitialScreening />} */}
          <div>
            {jsonType === "Auto_mapper_field" && <AutoMappedFields files={showFiles} setMappedSelectedFile={setMappedSelectedFile} mappedFile={mappedSelectedFile} />}
            {jsonType === "review_and_validation" && <FileUploaded files={showFiles} setMappedSelectedFile={setMappedSelectedFile} mappedFile={mappedSelectedFile} json_response={jsonResponse} />}
            {jsonType === "quick_health" && <QuickHealth json_response={jsonResponse} />}
            {jsonType === "proposed_visuals" && <VisualConfirmation json_response={jsonResponse} />}
            {jsonType === "schema_validation_field_level_diagnostic" && <SchemaValidation json_response={jsonResponse} />}
            {jsonType === "proposed_cleanup" && <ProposedCleanup json_response={jsonResponse} onContinue={() => { handleSendQuery(query, "Continue", undefined) }} />}
            {jsonType === "objective_confirmation" && <ObjectiveConfirmation json_response={jsonResponse} onContinue={() => { handleSendQuery(query, "Continue", undefined) }} />}
            {jsonType === "checklist" && <StatusChecklist files={showFiles} />}
            {jsonType === "auto_filled_summary" && <AutoFilledSummaryTable file={mappedSelectedFile} />}

            {jsonType === "insights_adoption_agent" && <SentimentInsightsUI response={jsonResponse.insights} />}
            {jsonType === "challenge_mapping_adoption_agent" && <ChallengeMappingUI response={jsonResponse} />}
            {jsonType === "support_strategy_adoption_agent" && <SupportStrategiesUI response={jsonResponse} />}
            {jsonType === "persona_segmentation_adoption_agent" && <PersonaSegmentation response={jsonResponse} />}
            {jsonType === "report_generation_adoption_agent" && <ReportGeneration response={jsonResponse} agentName={agent} />}
            {jsonType === "market_intelligence_report_adoption_agent" && <CarTReport response={jsonResponse} userId={userId} threadId={threadId} />}
            {jsonType === "targeted_patient_segments_adoption_agent" && <PatientSegment response={jsonResponse} />}
            {jsonType === "interview_guide_drafting_adoption_agent" && <InterviewGuide response={jsonResponse} />}
            {jsonType === "template_confirmation_adoption_agent" && <TemplateConfirmation response={jsonResponse} />}
            {jsonType === "report_on_anything_agent_v3_report_template" && <AnythingReportTemplate reportData={jsonResponse} />}

            {/* Newsletter Agent */}
            {jsonType == "newsletter_agent_wireframe" && <NewsletterWireframe response={jsonResponse} onConfirm={() => setWireframeConfirmed(true)} />}
            {jsonType == "newsletter_agent_context_preview" && <NewsletterContextPreview response={jsonResponse} onConfirm={() => setContextPreview(true)} />}
            {jsonType == "newsletter_agent_email_layout" && <NewsletterEmailPreview response={jsonResponse} onConfirm={() => setEmailPreview(true)} />}
            {jsonType == "newsletter_agent_content_audit" && <NewsletterContextAudit response={jsonResponse} />}
            {jsonType == "newsletter_agent_final_output" && <NewsletterFinalOutput response={jsonResponse} />}
            {jsonType == "newsletter_agent_data_collection" && <NewsletterCollection response={jsonResponse} threadId={thread_id} userId={userId || " "} onConfirm={() => setDataCollected(true)} />}
            {jsonType == "newsletter_agent_v2_email_layout" && <EmailLayout response={jsonResponse} threadId={thread_id} userId={userId || " "} />}

            {jsonType === "quant_ingestion_panel" && <QuantIngestionPanel json_response={jsonResponse} />}
            {jsonType === "quant_validation_panel" && <QuantValidationPanel json_response={jsonResponse} />}
            {jsonType === "quant_chart_panel" && <QuantChartPanel json_response={jsonResponse} />}
            {jsonType === "quant_insights_panel" && <QuantInsightsPanel json_response={jsonResponse} />}
            {jsonType === "quant_deck_preview" && (<TemplateQuantAgent response={jsonResponse} />)}
            {jsonType === "quant_charting_panel" && (<ChartingPanel response={jsonResponse} />)}

            {jsonType === "ppt_template_generation_adoption_agent" && (<PresentationRightPanel response={jsonResponse} threadId={thread_id} userId={userId} />)}

            {jsonType === "report_on_anything_agent_v2_final_summary" && (<ReportAnythingReport response={jsonResponse} />)}

            {jsonType === "whitepaper_agent_v1_table_of_contents" && (<TableOfContent response={jsonResponse} />)}
            {jsonType === "whitepaper_agent_v1_data_sources" && (<WhitePaperDataSources response={jsonResponse} />)}
            {/* {jsonType === "whitepaper_agent_v1_whitepaper_generated" && (<Report response={jsonResponse} />)} */}

            {/* {jsonType === "data_collection_adoption_agent" && <DataCollectionAdoptionAgent />} */}
            {/* jsonType === "summary_panel" && <ModelComponentsTable /> */}
            {/* <ReportCustomization /> */}
            {dataSources && Object.keys(dataSources || {}) && (
              <SourcesData
                dataSource={{
                  ...dataSources,
                  ...(agent === "customer-360-agent" || agent === "investment-diligence-agent" || agent === "marketing-agent"
                    ? {
                      Internal: dataSources?.Internal?.length
                        ? dataSources?.Internal
                        : showFiles?.map((file) => file.name) || [],
                    }
                    : {}),
                }}
              />
            )}
            {jsonType === "Final_report" && jsonResponse?.sections && (
              <TemplateReport reportSummary={jsonResponse.sections} />
            )}

            {jsonType === "campaign_template" && (
              <CampaignTemplateReport campaignData={jsonResponse} onSave={handleCampaignSave} />
            )}

            {jsonType === "connector_input" && (
              <ConnectorSetup campaignData={connectorInput?.userId} />
            )}
            {jsonResponse?.keywords ? (
              <Keywords
                dataSource={jsonResponse.keywords}
                updateUserInput={(value: string) => {
                  setanswer(`${query} ${value}`);
                }}
                answer={answer}
              />
            ) : null}
            {Step == 3 && <InitialScreening />}
          </div>
        </div>
      </div>
    </>
  );
};

export default AiAgent;
